usersModule.controller('EditUsersController',
    ['$scope', 'User', 'usersEditService', 'identityMgmntService', 'imSessionVarsService', 'usersMgEvents', 'authRoles',
        'TLCError','AppErrorCodes',
        function ($scope, User, usersEditService, identityMgmntService, imSessionVarsService, usersMgEvents, authRoles,
        TLCError,AppErrorCodes) {
            $scope.user = new User();
            $scope.loginIdAvailable = false;
            $scope.emailIsValid = false;
            $scope.editMode = false;
            $scope.roles = [];
            var Role = function(){
                this.roleName = '';
                this.roleDisplay = '';
                this.roleSelected = false;
                this.roleEnable = false;
            };
            $scope.reset = {};
            $scope.reset.successMessage = "Password reset successfully. You should receive an email with the new password shortly.";
            $scope.reset.done = false;

            loadRoles();

            function loadRoles(){
                var appSPAN = identityMgmntService.getRolesAndPrivileges()
                    .then(function (response) { // resolved
                        if (response.length > 0) {
                            _.each(response[0].Roles, function(role){
                                var objRole = new Role();
                                objRole.roleName = role.RoleName.toUpperCase();
                                objRole.roleDisplay = role.RoleName.toUpperCase().replace('SPAN', '');
                                $scope.roles.push(objRole);
                            });
                            enableRoles();
                        };
                    });
            };

            $scope.createUser = function() {
                if($scope.loginIdAvailable && $scope.emailIsValid) {
                    $scope.editMode = true;
                    usersEditService.createUser($scope.user)
                        .success(function(responseData, status){
                            var tempUser = new User();
                            tempUser.populateDataFromIdentityManagement(responseData);
                            $scope.$broadcast(usersMgEvents.userCreate, tempUser);
                        })
                        .error(function(responseData, status) {
                            throw new TLCError(new Error('Error creating user: ' + responseData),AppErrorCodes.UserController_SaveError);
                        });
                }
            };

            $scope.updateUser = function() {
                if($scope.editMode) {
                    if($scope.emailIsValid) {
                        usersEditService.updateUser($scope.user)
                            .success(function(responseData, status){
                                //Broadcast the event to signalize that the user has been updated, in order to update it in memory
                                $scope.$broadcast(usersMgEvents.userUpdate, $scope.user);
                            })
                            .error(function(responseData, status) {
                                throw new TLCError(new Error('Error updating user: ' + responseData),AppErrorCodes.UserController_SaveError);
                            });
                    }
                } else {
                    $scope.createUser();
                }
            };

            $scope.resetAndEmailPassword = function () {
                var resetParameters = {UserName: $scope.user.loginId, Email: $scope.user.email};
                usersEditService.resetAndEmailPassword(resetParameters)
                    .success(passwordResetSuccessful)
                    .error(function (response) {
                        var message = angular.isString(response) ? response : "Password reset failed";
                        throw new TLCError(new Error(message),AppErrorCodes.UserController_PasswordResetError);
                    });
            };

            //When a role is selected or deselected, add it to the user
            $scope.roleChanged = function(role){
                if (role.selected)
                //TODO: I'm no sure if we are required to add the type for the roles, I tried adding a role without the type, and it worked fine; hence, I need to confirm if it's required for some reason
                    $scope.user.roles.push({'Type': 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role', 'Value': role.roleName});
                else {
                    var deleteRole = arrayObjectIndexOf($scope.user.roles, role.roleName, "Value");
                    $scope.user.roles.splice(deleteRole, 1);
                }
            };

            function arrayObjectIndexOf(myArray, searchTerm, property) {
                for(var i = 0, len = myArray.length; i < len; i++) {
                    if (myArray[i][property].toUpperCase() === searchTerm.toUpperCase()) return i;
                }
                return -1;
            };

            $scope.clearInputs = function() {
                $scope.reset.done = false;
                $scope.user = new User();
                _.each($scope.roles, function(role){
                    role.selected = false;
                });
                $scope.editMode = false;
                $scope.$broadcast(usersMgEvents.userClear);
            };

            $scope.checkLoginIdAvailability = function() {
                if($scope.user && $scope.user.loginId) {
                    usersEditService.checkLoginIdAvailability($scope.user.loginId)
                        .success(function (responseData, status) {
                            $scope.loginIdAvailable = responseData;
                        })
                        .error(function (responseData, status) {
                            $scope.loginIdAvailable = false;
                            throw new TLCError(new Error('Error checking login id availability: ' + responseData),AppErrorCodes.SearchController_GeneralError);
                        });
                } else {
                    $scope.loginIdAvailable = false;
                }
            };

            $scope.checkValidEmailFormat = function() {
                //  Email format validation is actually really complex.
                // See this SO discussion for details (http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address)

                //  Another possible option is to use a module like this (https://github.com/globesherpa/node-isemail) but that
                // seems like overkill.
                // For now, we are only checking to see if:
                //  1. There is an @ sign
                //  2. It isn't the first character and
                //  3. There is something after it
                $scope.emailIsValid = 0 < $scope.user.email.indexOf('@') && ($scope.user.email.indexOf('@') + 1) < $scope.user.email.length;
            };

            $scope.$on(usersMgEvents.userSelected, function(event, user) {
                $scope.reset.done = false;
                $scope.user = angular.copy(user);
                //Initializing the roles to deselected
                _.each($scope.roles, function(scopeRole){
                    scopeRole.selected = false;
                });
                //Selecting the roles assigned to the selected user
                _.each(user.roles, function(role){
                    _.each($scope.roles, function(scopeRole){
                        if (scopeRole.roleName.toUpperCase() == role.Value.toUpperCase())
                            scopeRole.selected = true;
                    });
                });
                $scope.editMode = true;
            });

            $scope.$watch('user.loginId', function(newVal, oldVal) {
                // login id doesn't need to be checked in editMode because it cannot be changed after creation
                if(newVal !== oldVal && !$scope.editMode)
                    $scope.checkLoginIdAvailability();
            });

            $scope.$watch('user.email', function(newVal, oldVal) {
                if(newVal !== oldVal)
                    $scope.checkValidEmailFormat();
            });

            function passwordResetSuccessful() {
                $scope.reset.done = true; // enable done message  & link
            };

            function roleEnabledDisabled(role, enable){
                _.each($scope.roles.filter(function (val) {
                    return val.roleName == role;
                }), function(selectedRole){
                    selectedRole.roleEnable = enable;
                });
            };

            //Enable roles according to the role of the logged in user
            function enableRoles() {
                var userRoles = imSessionVarsService.getCurrentIMUserRoles();
                if (userRoles) {
                    for (var i = 0; i < userRoles.length; i++) {
                        var role = userRoles[i];
                        //role = role.replace(/ /g, '_');
                        switch (role.toUpperCase()) {
                            case authRoles.dealerOfficeManager:
                                roleEnabledDisabled(authRoles.dealerOfficeManager, true);
                                break;
                            case authRoles.providerCorp:
                                roleEnabledDisabled(authRoles.fiManager, true);
                                //TODO - Only show F&I Manager - Rating Only for APCO
                                roleEnabledDisabled(authRoles.fiManagerRateOnly, true);
                                roleEnabledDisabled(authRoles.dealerOfficeManager, true);
                                roleEnabledDisabled(authRoles.providerCorp, true);
                                roleEnabledDisabled(authRoles.providerFieldRep, true);
                                roleEnabledDisabled(authRoles.providerRepManager, true);
                                break;
                            case authRoles.providerFieldRep:
                                roleEnabledDisabled(authRoles.fiManager, true);
                                //TODO - Only show F&I Manager - Rating Only for APCO
                                roleEnabledDisabled(authRoles.fiManagerRateOnly, true);
                                roleEnabledDisabled(authRoles.dealerOfficeManager, true);
                                break;
                            case authRoles.providerRepManager:
                                roleEnabledDisabled(authRoles.fiManager, true);
                                //TODO - Only show F&I Manager - Rating Only for APCO
                                roleEnabledDisabled(authRoles.fiManagerRateOnly, true);
                                roleEnabledDisabled(authRoles.dealerOfficeManager, true);
                                roleEnabledDisabled(authRoles.providerFieldRep, true);
                                break;
                            case authRoles.admin:
                                _.each($scope.roles, function (roleEnabled) {
                                    roleEnabled.roleEnable = true;
                                });
                                break;
                            case authRoles.providerCorpAdmin:
                                _.each($scope.roles, function (roleEnabled) {
                                    roleEnabled.roleEnable = true;
                                });
                                roleEnabledDisabled(authRoles.admin, false);
                                break;
                            default:
                                break;
                        }
                    }
                }
            };

        }
    ]);
